'use client';
var EventBus = function() {
    var emit = function emit(eventName) {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
            args[_key - 1] = arguments[_key];
        }
        var listeners = eventListeners.get(eventName);
        if (!listeners) {
            return;
        }
        listeners.forEach(function(listener) {
            return listener.apply(void 0, [].concat(args));
        });
    };
    var on = function on(eventName, listener) {
        if (!eventListeners.has(eventName)) {
            eventListeners.set(eventName, new Set());
        }
        var listeners = eventListeners.get(eventName);
        listeners.add(listener);
        return function unsubscribe() {
            var listeners = eventListeners.get(eventName);
            if (!(listeners == null ? void 0 : listeners.has(listener))) {
                return;
            }
            listeners.delete(listener);
            if (listeners.size === 0) {
                eventListeners.delete(eventName);
            }
        };
    };
    var eventListeners = new Map();
    var eventBus = {
        emit: emit,
        on: on
    };
    return eventBus;
};

export { EventBus };
